// src/registerServiceWorker.js
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register(`${process.env.BASE_URL}firebase-messaging-sw.js`)
      .then((registration) => {
        console.log('Service Worker registration successful with scope: ', registration.scope);
      })
      .catch((err) => {
        console.error('Service Worker registration failed: ', err);
      });
}  